<form (ngSubmit)="lookUp()" [formGroup]="lookUpForm">
    <div style="width: 500px">
        <div class="title">Look up promo code</div>

        <app-alert/>

        <div class="label">Code</div>
        <input autofocus class="field" formControlName="code" required type="text" style="text-transform: uppercase;">

        <button [disabled]="!lookUpForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Search</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../../assets/img/spinner.svg"/>
        </button>

        <div class="promo-code-info" *ngIf="promoCode() != null">
            <div class="promo-code-header">
                <h3 class="promo-code-title">Promo Code Details</h3>
            </div>

            <div class="info-grid">
                <div class="info-item">
                    <div class="info-label">Type</div>
                    <div class="info-value">{{ promoCode()!.type }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Batch</div>
                    <div class="info-value">{{ promoCode()!.batch }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Description</div>
                    <div class="info-value">{{ promoCode()!.description }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Category</div>
                    <div class="info-value">{{ promoCode()!.category }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Expiration</div>
                    <div class="info-value">{{ promoCode()!.expiration }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Iid</div>
                    <div class="info-value">{{ promoCode()!.iid || 'Not assigned' }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Bind at</div>
                    <div class="info-value">{{ promoCode()!.bindAt || 'Not bound' }}</div>
                </div>

                <div class="info-item">
                    <div class="info-label">Purchase ID</div>
                    <div class="info-value">{{ promoCode()!.purchaseId || 'Not used' }}</div>
                </div>

                <div class="info-item" *ngIf="promoCode()!.publicConsumptionCount != null">
                    <div class="info-label">Consumed count</div>
                    <div class="info-value">{{ promoCode()!.publicConsumptionCount }}</div>
                </div>
            </div>

            <div class="status-badge" *ngIf="promoCode()!.publicConsumptionCount == null" [ngClass]="promoCode()!.purchaseId ? 'status-used' : 'status-available'">
                {{ promoCode()!.purchaseId ? 'Used' : 'Available' }}
            </div>

            <div class="consumed-info" *ngIf="promoCode()!.purchaseId">
                <div class="consumed-title">Consumed Information</div>
                <div class="consumed-details">
                    This promo code was used for purchase #{{ promoCode()!.purchaseId }}
                    {{ promoCode()!.bindAt ? 'on ' + promoCode()!.bindAt : '' }}
                </div>
            </div>
        </div>
    </div>
</form>